import {Box, CircularProgress} from "@mui/material";
import {FolioService} from "crqlar-react-common/dist/services/billing/folio.service";
import {useTrackScreenVisit} from "crqlar-react-common/dist/utils/analytics.util";
import {useMemo} from "react";
import {useNavigate} from "react-router-dom";
import {useSettingsAccess} from "./useSettingsAccess";
import SettingsMobileLanding from "./settings/SettingsMobileLanding";
import SettingsLandingSearch from "./settings/search/SettingsLandingSearch";
import type {SettingsSearchResult} from "./settings/search/settingsSearch.types";
import {useSettingsSearchConfig} from "./settings/search/useSettingsSearchConfig";
import SettingsPageHeader from "./layout/SettingsPageHeader";

const StartPage = () => {
    useTrackScreenVisit('system start page')

    const navigate = useNavigate()
    const {isLoading, sections, hasGuestAppModule, canAccessSettingsItem} = useSettingsAccess()
    const searchConfig = useSettingsSearchConfig({sections, hasGuestAppModule, canAccessSettingsItem})
    const additionalResults = useMemo<SettingsSearchResult[]>(() => (
        canAccessSettingsItem('folios') ? [{
            id: 'create-folios',
            section: 'create',
            label: 'Create folio',
            group: 'Billing',
            keywords: ['folio', 'billing'],
            onSelect: async () => {
                const folio = await FolioService.create({})
                navigate(`/system/folios/${folio.id}`)
            },
        }] : []
    ), [canAccessSettingsItem, navigate])

    if (isLoading) {
        return (
            <>
                <SettingsPageHeader title={null} back={() => navigate('/')} mobileOnly loading/>
                <Box sx={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center'}}>
                    <CircularProgress size={20}/>
                </Box>
            </>
        )
    }

    return (
        <>
            <SettingsPageHeader title={null} back={() => navigate('/')} mobileOnly/>

            <Box sx={{display: {xs: 'block', md: 'none'}, width: '100%'}}>
                <SettingsMobileLanding
                    {...searchConfig}
                    additionalResults={additionalResults}
                    sections={sections}
                />
            </Box>

            <Box
                sx={{
                    display: {xs: 'none', md: 'block'},
                    width: '100%',
                    height: '100%',
                    minHeight: 0,
                    overflow: 'hidden',
                }}
            >
                <SettingsLandingSearch {...searchConfig} additionalResults={additionalResults}/>
            </Box>
        </>
    )
}

export default StartPage
